import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'
import { peopleManagedByEmployee } from 'modules/employees/store/collections/employeesContractVersions'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { peopleLedByEmployee } from 'modules/teams/store/peopleLedByEmployee'

const employeeStatusFilter = (
  source: ReturnType<typeof useDocumentsDataTable>,
  contractVersions: ContractVersions
) => {
  const currentEmployee = users.current.employee
  const activeEmployees = employees
    .filter((employee) => !employee.isTerminated)
    .map((employee) => employee.id)
  const pastEmployees = employees
    .filter((employee) => employee.isTerminated)
    .map((employee) => employee.id)
  const ledByCurrent = currentEmployee
    ? peopleLedByEmployee(teams, memberships, currentEmployee.id, contractVersions).map(
        (employee) => employee.id
      )
    : []
  const managedByCurrent = currentEmployee
    ? peopleManagedByEmployee(currentEmployee.id, contractVersions).map((employee) => employee.id)
    : []

  const employeeStatusOptions = [
    {
      value: activeEmployees,
      label: i18n.t('documents.employee.filters.employee_status_options.active_employees'),
    },
    {
      value: pastEmployees,
      label: i18n.t('documents.employee.filters.employee_status_options.past_employees'),
    },
    {
      value: managedByCurrent,
      label: i18n.t('documents.employee.filters.employee_status_options.report_direct'),
    },
    {
      value: ledByCurrent,
      label: i18n.t('documents.employee.filters.employee_status_options.report_me'),
    },
  ]
  const options = employeeStatusOptions.filter(({ value }) => value.length > 0)

  return buildDocumentsDataTableFilter(source, {
    type: FilterType.Integer,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'employee_status',
    path: 'employeeStatus',
    title: i18n.t('documents.employee.filters.employee_status'),
  })
}

export default employeeStatusFilter
